module.exports = __webpack_public_path__ + "static/media/plakat-sk.aff10bc9.svg";